import React from 'react';

import ConversationAssistant, {
	type ConversationAssistantConfig,
} from '@atlassian/conversation-assistant';

type StagingAreaChatContainerProps = {
	config: ConversationAssistantConfig;
};

export const StagingAreaChatContainer = ({ config }: StagingAreaChatContainerProps) => {
	return (
		<ConversationAssistant
			config={config}
			testId="staging-area-conversation-assistant"
			uiConfig={{
				externalEmbed: true,
				fullScreen: true,
				elements: {
					closeButton: false,
					fullscreenButton: false,
					newChatButton: false,
					browseAgentsButton: false,
					createAgentButton: false,
					agentsMenu: false,
				},
			}}
		/>
	);
};
